import ChromeExtensionService from 'services/ChromeExtensionService';

export function isChromeWithoutExclusions(): boolean {
  const lowerCaseUserAgent: string = navigator.userAgent.toLowerCase();
  const containsChrome = lowerCaseUserAgent.includes('chrome');
  const containsEdg = lowerCaseUserAgent.includes('edg');
  const containsOPR = lowerCaseUserAgent.includes('opr');
  return containsChrome && !containsEdg && !containsOPR;
}

export async function checkHasChromeExtension(): Promise<boolean> {
  return await ChromeExtensionService.isAvailable();
}
